import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import FooterDisplay from "../../components/footer";

const menuItems = [
  {
    key: "home",
    to: "/biker/dashboard",
    icon: "home",
    label: "Home",
  },
  {
    key: "profile",
    to: "/biker/profile",
    icon: "person",
    label: "Profile",
  },
  {
    key: "tools",
    to: "/settings",
    icon: "settings",
    label: "Tools",
  },
];

const DeliveryLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active section based on current path
  const getActiveSection = () => {
    if (location.pathname === "/biker/home") return "home";
    if (location.pathname === "/biker/profile") return "profile";
    if (location.pathname === "/biker/tools") return "tools";
    return "home";
  };

  const handleSectionChange = (section) => {
    const menuItem = menuItems.find((item) => item.key === section);
    if (menuItem) {
      navigate(menuItem.to);
    }
  };

  return (
    <div className="userprofile">
      <div className="profile-content pb-40">
        <div className="gray_bg_profile">
          <div className="profile_to_left">
            <div className=""></div>
          </div>
          <div className="profile_to_right">
            <div className="contain">
              <div className="main_container">{children}</div>
            </div>
          </div>
        </div>
      </div>

      <FooterDisplay
        activeSection={getActiveSection()}
        menuItems={menuItems}
        onSectionChange={handleSectionChange}
      />
    </div>
  );
};

export default DeliveryLayout;
